const isProduction = process.env.NODE_ENV === 'production';
export const API = isProduction ? 'https://emarket.do' : '//localhost:3000';
export const AUTH_URL = isProduction ? '/api/auth/email' : '//localhost:3000/api/auth/email';



// WEBPACK FOOTER //
// ./client/app/common/config/config.js